import styled from "styled-components";

export const DeleteMessage = styled.p`
padding-top: ${({ theme }) => theme.spacing.sm};
`